import { createSlice } from '@reduxjs/toolkit'

export const drgMgtSlice = createSlice({
    name: 'drgMgt',
    initialState: {
        drgFiles: [], // allDRGInProjectSlice
        currentDRG: undefined, // regulatioryFileSlice
        regulatoryFileAction: undefined, // regulatoryFileActionSlice
        hasDRGFile: false, // hashFileChangeSlice
        hasDiagramChange: false, // hashDiagramChangeSlice
        drgValidation: null, // drgValidationSlice
        clickNextFile: null // clickNextFileSlice
    },
    reducers: {
        setDRGFiles: (state, action) => {
            state.drgFiles = action.payload;
        },
        setCurrentDRG: (state, action) => {
            state.currentDRG = action.payload;
        },
        setRegulatoryFileAction: (state, action) => {
            state.regulatoryFileAction = action.payload;
        },
        setHasDRGFile: (state, action) => {
            state.hasDRGFile = action.payload;
        },
        setHasDiagramChange: (state, action) => {
            state.hasDiagramChange = action.payload;
        },
        setDrgValidation: (state, action) => {
            state.drgValidation = action.payload;
        },
        setClickNextFile: (state, action) => {
            state.clickNextFile = action.payload;
        }
    },
})

export const {
    setDRGFiles,
    setCurrentDRG,
    setRegulatoryFileAction,
    setHasDRGFile,
    setHasDiagramChange,
    setDrgValidation,
    setClickNextFile
} = drgMgtSlice.actions;

export const getDRGFiles = (state) => state.drgMgt.drgFiles;
export const getCurrentDRG = (state) => state.drgMgt.currentDRG;
export const getRegulatoryFileAction = (state) => state.drgMgt.regulatoryFileAction;
export const getHasDRGFile = (state) => state.drgMgt.hasDRGFile;
export const getHasDiagramChange = (state) => state.drgMgt.hasDiagramChange;
export const getDrgValidation = (state) => state.drgMgt.drgValidation;
export const getClickNextFile = (state) => state.drgMgt.clickNextFile;

export default drgMgtSlice.reducer